/**
 * The option lists behind every planning control (properties panel, row
 * menu, bulk bar), so they cannot disagree.
 *
 * @module components/regulation/finding/findingPickers
 */
import { CalendarIcon, UserRoundXIcon } from "lucide-react";

import type { OrganizationPerson } from "../../../state/governance";
import { duePresets } from "./FindingsQueue.logic";
import { PersonFace, personLabel } from "./findingGlyphs";
import type { PickerOption } from "./Picker";

export const NO_ASSIGNEE = "";

export const assigneeOptions = (people: ReadonlyArray<OrganizationPerson>, current: string | null): PickerOption[] => [
  { value: NO_ASSIGNEE, label: "No assignee", icon: <UserRoundXIcon className="size-3.5" />, checked: current === null },
  ...people.map((person) => ({
    value: person.userId,
    label: personLabel(person),
    icon: <PersonFace person={person} className="size-4 text-[8px]" />,
    checked: person.userId === current,
  })),
];

const shortDay = (day: string) =>
  new Date(`${day}T00:00:00Z`).toLocaleDateString("en-GB", { day: "numeric", month: "short", timeZone: "UTC" });

export const REMOVE_DUE_DATE = "";

export function dueOptions(current: string | null, now: number = Date.now()): PickerOption[] {
  return [
    ...duePresets(now)
      .filter((preset, index, all) => all.findIndex((other) => other.day === preset.day) === index)
      .map((preset) => ({
      value: preset.day,
      label: preset.label,
      icon: <CalendarIcon className="size-3.5" />,
      hint: shortDay(preset.day),
      checked: preset.day === current,
    })),
    ...(current ? [{ value: REMOVE_DUE_DATE, label: "Remove due date", icon: <CalendarIcon className="size-3.5" /> }] : []),
  ];
}
